export default {"src":"/_next/static/media/Upload.4e44f743.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};